// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__sMKRi","checkmark":"Checkbox_checkmark__2FjeV"};